import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner, Typography, WithInfoIcon } from 'seagull';
import GraphWidgetTopCard from './GraphWidgetTopCard';
import styles from './ThreeLineTopCard.module.scss';
export default function ThreeLineTopCard(param) {
    let { title, secondaryText, primaryText, titleInfo = '', secondaryInfo = '', loading, success, testId, linkTo } = param;
    return /*#__PURE__*/ _jsx(GraphWidgetTopCard, {
        className: styles.topCard,
        linkTo: linkTo,
        children: /*#__PURE__*/ _jsxs("div", {
            "data-testid": loading ? "".concat(testId, "-loading") : testId,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(WithInfoIcon, {
                        showInfo: !!titleInfo,
                        info: titleInfo,
                        infoTestId: testId && "".concat(testId, "-info"),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            ellipsis: true,
                            variant: "paragraph1",
                            skin: success ? 'success' : 'standard',
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "normal",
                    testId: testId && "".concat(testId, "-primary"),
                    children: loading ? /*#__PURE__*/ _jsx(Spinner, {
                        size: 30
                    }) : primaryText
                }),
                secondaryText && /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(WithInfoIcon, {
                        showInfo: !!secondaryInfo,
                        info: secondaryInfo,
                        size: "s",
                        children: /*#__PURE__*/ _jsxs(Typography, {
                            variant: "paragraph2",
                            skin: "secondary",
                            testId: testId && "".concat(testId, "-secondary"),
                            children: [
                                loading && /*#__PURE__*/ _jsx(Spinner, {
                                    size: 20
                                }),
                                secondaryText
                            ]
                        })
                    })
                })
            ]
        })
    });
}
